import { apiGet, apiPut } from "./http";
import { mergeLandingPage, type LandingPageConfig } from "./landingPageConfig";

/** 服务端已对 JSON 内图片 URL 做 ToDisplayUrl（私有桶时为预签名 URL），前端直接用于 img/src、background 等即可。 */

export async function fetchLandingPageConfig(tenantLegacyId: string): Promise<LandingPageConfig> {
  const raw = await apiGet<unknown>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/landing-page`);
  return mergeLandingPage(raw);
}

export function putLandingPageConfig(tenantLegacyId: string, config: LandingPageConfig) {
  return apiPut<unknown>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/landing-page`,
    config,
  );
}
